(function($){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function() {
    (function () {
      const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;
  
      // get value rom data attribute from c-countdown class
      event_date = document.querySelector('.c-countdown').getAttribute("data-event-date");
      
      const countDown = new Date(event_date).getTime(),
          x = setInterval(function() {  
            const now = new Date().getTime(),
                  distance = countDown - now;
              document.getElementById("days").innerText = Math.floor(distance / (day)),
              document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
              document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
              document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);
    
            //do something later when date is reached
            if (distance < 0) {
              document.getElementById("headline").style.display = "block";
              document.getElementById("countdown").style.display = "none";
              clearInterval(x);
            }
            //seconds
          }, 0)
      }());
  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
    $('.c-countdown').each(function(){
      initializeBlock( $(this) );
    });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=gdt/countdown', initializeBlock );
  }

})(jQuery);